<template>
	<sf-data-table
		ref="PmcTrackingTable"
		paging
		:pageUnit="groups.pageUnit"
		:totalSize="groups.totalSize"
		:columns="pmcTrackingCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		:selection="false"
		:customExcel="excelFunc"
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft />
		<template v-slot:actionsRight />
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

/*엑셀다운로드 시작*/
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
/*엑셀다운로드 끝*/
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.gridList;
		},
		pmcTrackingCols() {
			return [
				{
					label: this.getMessage_('QWCC001015'), //차량구분
					prop: 'carScnNm',
					width: '100px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('SWCC000570'), // VIN no
					prop: 'carVin',
					width: '200px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001021'), // 연료전지사양
					prop: 'flclSpcNm',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001056'), // 연료전지사양, // Ctype
					prop: 'ctypeNm',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001245'), // RO번호
					prop: 'roNo',
					width: '200px',
					align: 'center',
					highlight: true,
					clickEvent: this.openRoApcnPopupModal
				},
				{
					label: this.getMessage_('QWCC001097'), //교환부품정보
					width: '400px',
					align: 'center',
					sortable: false,
					children: [
						{
							label: this.getMessage_('QWCC000956'), // 품번
							prop: 'partNo',
							width: '200px',
							headerAlign: 'center',
							align: 'center'
						},
						{
							label: this.getMessage_('QWCC000957'), // 품명
							prop: 'partNm',
							minWidth: '200px',
							headerAlign: 'center',
							align: 'left'
						},
						{
							label: this.getMessage_('QWCC000977'), // 교환부품수량
							prop: 'qty',
							width: '100px',
							align: 'right'
						}
					]
				},

				{
					label: this.getMessage_('QWCC001174'), // R/O 확정일
					prop: 'dcsnDd',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001024'), // 캠페인 No
					prop: 'cmpnNo',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001007'), // 캠페인 명
					prop: 'cmpnNm',
					width: '130px',
					align: 'center'
				}
			];
		},
		pmcTrackingExcelCols() {
			return [
				{
					label: this.getMessage_('QWCC001015'), //차량구분
					prop: 'carScnNm',
					width: '100px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('SWCC000570'), // VIN no
					prop: 'carVin',
					width: '200px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001021'), // 연료전지사양
					prop: 'flclSpcNm',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001056'), // 연료전지사양, // Ctype
					prop: 'ctypeNm',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001245'), // RO번호
					prop: 'roNo',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000956'), // 품번
					prop: 'partNo',
					width: '200px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000957'), // 품명
					prop: 'partNm',
					minWidth: '200px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000977'), // 교환부품수량
					prop: 'qty',
					width: '100px',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001174'), // R/O 확정일
					prop: 'dcsnDd',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001024'), // 캠페인 No
					prop: 'cmpnNo',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001007'), // 캠페인 명
					prop: 'cmpnNm',
					width: '130px',
					align: 'center'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		openRoApcnPopupModal(row) {
			/*RO신청 버튼 클릭시*/
			//console.log('그리드에서 클레임번호를 클릭했을때>', row);

			const selRoNo = convertNvl(row.roNo, '');

			if (selRoNo != '') {
				const param = {
					title: this.getMessage_('QWCC001769'), //RO상세
					roNo: selRoNo
				};
				this.$emit('PopupRoOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
			}
		},
		excelFunc() {
			let queryStr = '';

			queryStr = objectToQuerystring({
				pmcId: this.searchParams.pmcId ,
				carVin: this.searchParams.carVin 
			});

			const url = `${BASE_URL}/mqy/qlty/pmcTracking/v1/excels`+ queryStr;

			const params = { url, columns: this.pmcTrackingExcelCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh', currentPageVal, pageUnitVal);
		}
	}
};
</script>

<style></style>
